<template>
  <section>
    <nav>
      <a :href="`/cioccolato/${page.slug}`" v-for="(page, index) in pages" :key="index" @click.prevent="navClick(index)" :class="index === currentPageIndex ? 'active' : ''">{{ page.name }}</a>
    </nav>
    <div class="heroCioccolato">
      <h1 class="neue">Un cioccolato davvero buono? Quello che nasce da relazioni giuste e cura dei territori.</h1>
      <div>
        Dietro una tavoletta si celano spesso gravi squilibri:
      </div>
      <div>
        deforestazione, perdita di biodiversità, sfruttamento del lavoro minorile e povertà diffusa tra i coltivatori. La nostra risposta è il Commercio Giusto: lavoriamo direttamente con le cooperative agricole, garantendo contratti duraturi,con attenzione al rispetto dei diritti dei lavoratori e un prezzo minimo di garanzia che protegge le comunità dalle oscillazioni di mercato. 
      </div>
      <div>
        Scopri la differenza di un cioccolato nato dal Commercio Giusto. <a href="https://www.altromercato.it/filiere/cacao/" target="_blank">Scopri di più</a>
      </div>
    </div>
    <div v-touch:swipe.left="spinCounterClockwise" v-touch:swipe.right="spinClockwise">
      <div :class="`packWheel ${spinClass}`">
        <a :href="`/cioccolato/${page.slug}`" v-for="(page, index) in bufferWheel" :key="index" @transitionend="index === 1 ? wheelTransitionEnd() : null" @click.prevent="packClick(index)">
          <img :src="require(`@/assets/paginaCioccolato/${page.slug}_pack.png`)" :alt="page.name" />
          <img :src="require(`@/assets/paginaCioccolato/${wheel[index].slug}_pack.png`)" :alt="wheel[index].name" />
          <div><span>{{ page.name }}</span><span>{{ wheel[index].name }}</span></div>
        </a>
      </div>
      <div class="wheelArrows">
        <button @click="spinCounterClockwise()" :disabled="spinClass!==''" class="arrowBtn--left">Prev</button>
        <button @click="spinClockwise()" :disabled="spinClass!==''" class="arrowBtn--right">Next</button>
      </div>
    </div>
    <div :class="`contentWrapper ${transitionDirection} ${transitionTo !== false ? 'transitioning' : ''}`" @transitionend="contentWrapperTransitionEnd">
      <div v-for="(page, index) in pages" :key="index" :style="`--cioccolato-color: ${page.color}`" :class="`${index === currentPageIndex ? 'current' : (index === transitionTo ? 'next' : '')}`">
        <div class="intro">
          <h3 class="neue">{{ page.intro.title }}</h3>
          <div style="white-space: pre-line">{{ page.intro.text }}</div>
        </div>
        <div class="schema neue">
          <div class="pack">
            <img :src="require(`@/assets/paginaCioccolato/${page.slug}_pack.png`)" :alt="page.name" width="1000" height="616"/>
            <img :src="require(`@/assets/paginaCioccolato/${page.slug}_pack.png`)" :alt="page.name" width="1000" height="616"/>
          </div>
          <ul>
            <li>
              <div class="content">
                <div v-html="highlightsIcons.texture" class="highlightIcon"></div>
                <h4>TEXTURE E GUSTO</h4>
                <div v-html="page.highlights.texture"></div>
              </div>
              <svg viewBox="0 -1 130.65 138.51" class="line"><path d="M0 .5h49.6l80.62 136.75"/></svg>
            </li>
            <li>
              <div class="content">
                <div v-html="highlightsIcons.provalocon" class="highlightIcon"></div>
                <h4>PROVALO CON</h4>
                <div v-html="page.highlights.provalocon"></div>
              </div>
              <svg viewBox="0 -1 130.65 88.51" class="line"><path d="M130 .5h-49.6l-80.62 66.75"/></svg>
            </li>
            <li>
              <div class="content">
                <div v-html="highlightsIcons.personalita" class="highlightIcon"></div>
                <h4>PERSONALITÀ</h4>
                <div v-html="page.highlights.personalita"></div>
              </div>
              <svg viewBox="0 -1 130.65 51" class="line"><path d="M0 48.82h29.6l100.62 -48.82"/></svg>
            </li>
            <li>
              <div class="content">
                <div v-html="highlightsIcons.origini" class="highlightIcon"></div>
                <h4>ORIGINI</h4>
                <div><strong>Cacao</strong><br>Colcocoa, Colombia<br><strong>Zucchero</strong><br>ESWATINI Sugar Assosiation, Eswatini MSS, Mauritius</div>
              </div>
              <svg viewBox="0 -1 130.65 71" class="line"><path d="M130 68.82l-29.6 -30l-100.62 -38.82"/></svg>
            </li>
          </ul>
        </div>
        <div class="schemaCarousel neue">
          <img :src="require(`@/assets/paginaCioccolato/${page.slug}_pack.png`)" :alt="page.name" class="pack" width="1000" height="615"/>
          <VueSlickCarousel v-bind="slick_schema" class="schemaCarouselWrapper">
            <div class="content">
              <div v-html="highlightsIcons.texture" class="highlightIcon"></div>
              <h4>TEXTURE E GUSTO</h4>
              <div v-html="page.highlights.texture"></div>
            </div>
            <div class="content">
              <div v-html="highlightsIcons.provalocon" class="highlightIcon"></div>
              <h4>PROVALO CON</h4>
              <div v-html="page.highlights.provalocon"></div>
            </div>
            <div class="content">
              <div v-html="highlightsIcons.personalita" class="highlightIcon"></div>
              <h4>PERSONALITÀ</h4>
              <div v-html="page.highlights.personalita"></div>
            </div>
            <div class="content">
              <div v-html="highlightsIcons.origini" class="highlightIcon"></div>
              <h4>ORIGINI</h4>
              <div><strong>Cacao</strong><br>Colcocoa, Colombia<br><strong>Zucchero</strong><br>ESWATINI Sugar Assosiation, Eswatini MSS, Mauritius</div>
            </div>
          </VueSlickCarousel>
        </div>
        <div class="cta">
          <router-link :to="page.productLink" class="button button-fondo">Vai a {{ page.name }}</router-link>
        </div>
      </div>
    </div>
    <VueSlickCarousel v-bind="slick_suppliers" v-if="suppliers.length" :style="`--cioccolato-color: ${pages[currentPageIndex].color}`" class="suppliersWrapper">
      <div v-for="(supplier, index) in suppliers" :key="index" class="supplier">
        <img :src="require(`@/assets/paginaCioccolato/supplier_${index}.webp`)" :alt="supplier.title" class="supplierImage" height="1922" width="758" />
        <div class="supplierDetails">
          <div v-html="suppliersMaps[index] || ''" class="supplierMap"></div>
          <div class="supplierText">
            <h3 class="neue">{{ supplier.title }}</h3>
            <div>
              <span v-html="supplier.text"></span>
              {{' '}}
              <a :href="supplier.link" target="_blank">Scopri&nbsp;di&nbsp;più&nbsp;&gt;</a>
            </div>
          </div>
        </div>
      </div>
    </VueSlickCarousel>
  </section>
</template>

<script>
import pages from '@/assets/paginaCioccolato/pages.json'
import suppliers from '@/assets/paginaCioccolato/suppliers.json'
import suppliersMaps from '@/assets/paginaCioccolato/suppliersMaps.json'
import highlightsIcons from '@/assets/paginaCioccolato/highlightsIcons.json'
import VueSlickCarousel from 'vue-slick-carousel'
export default {
  name: 'PaginaCioccolato',
  data(){
    return {
      pages,
      suppliers,
      suppliersMaps,
      highlightsIcons,
      currentPageIndex: 0,
      wheelCurrentPageIndex: 0,
      wheel: [],
      bufferWheel: [],
      spinClass: '',
      queue: [],
      transitionDirection: '',
      transitionTo: false,
      slick_suppliers: {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      },
      slick_schema: {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        loop: true,
        arrows: false,
        infinite: true,
        mobileFirst: true,
      }
    }
  },

  metaInfo () {
    this.$utils.trackPageView(this, { pageType: 108, pageTitle: 'Cioccolato' });
    return { title: 'Cioccolato' }
  },

  created() {
    const slug = this.$route.params.slug || pages[0].slug
    this.currentPageIndex = pages.findIndex(p => p.slug === slug)
    if(this.currentPageIndex === -1) {
      return this.$router.push('/')
    }
    this.wheelCurrentPageIndex = this.currentPageIndex
    this.updateBufferWheel()
    this.wheel = [...this.bufferWheel]
  },

  mounted() {
    requestAnimationFrame(this.scrollObserver)
    window.addEventListener('resize', this.resizeHandler)
    this.resizeHandler()
    this.watchItems(".schema svg.line path", (item, yOffset, maxYOffset) => {
      if(item.bottom > maxYOffset) {
        item.el.style.strokeDashoffset = item.totalLength
      } else if(item.bottom + item.height > maxYOffset) {
        item.el.style.strokeDashoffset = item.totalLength * (1 - (item.bottom - maxYOffset) / item.height)
      } else {
        item.el.style.strokeDashoffset = 0
      }
    })
    this.watchItems(".schema .content", (item, yOffset, maxYOffset) => {
      if(item.bottom > maxYOffset) {
        item.el.style.opacity = 0
      } else if(item.bottom + item.height > maxYOffset) {
        item.el.style.opacity = (maxYOffset - item.bottom) / item.height
      } else {
        item.el.style.opacity = 1
      }
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
    delete window._scrollObserver
  },

  components: {
    VueSlickCarousel
  },

  methods: {
    watchItems(selector, callback) {
      document.querySelectorAll(selector).forEach(el => this.refreshItemSizes(window._scrollObserver.watchList[window._scrollObserver.watchList.push({ el, callback }) - 1]))
    },
    refreshItemSizes(item) {
      const rect = item.el.getBoundingClientRect()
      item.top = rect.top + scrollY
      item.bottom = rect.bottom + scrollY
      item.height = rect.height
      if(!item.totalLength && item.el.getTotalLength) {
        item.totalLength = item.el.getTotalLength()
        item.el.style.strokeDasharray = item.totalLength
      }
    },
    resizeHandler() {
      window._scrollObserver = {
        viewportHeight: document.documentElement.clientHeight,
        lastYOffset: false,
        watchList: window._scrollObserver?.watchList || []
      }
      window._scrollObserver.watchList.forEach(this.refreshItemSizes);
    },
    scrollObserver() {
      if(!window._scrollObserver) return
      requestAnimationFrame(this.scrollObserver)
      const yOffset = pageYOffset
      if(window._scrollObserver.lastYOffset !== yOffset) {
        const maxYOffest = yOffset + window._scrollObserver.viewportHeight;
        window._scrollObserver.watchList.forEach(item => {
          if((item.top < maxYOffest) && (item.bottom > yOffset)) {
            item.callback(item, yOffset, maxYOffest)
          }
        });
        window._scrollObserver.lastYOffset = yOffset;
      }
    },
    updateBufferWheel() {
      this.bufferWheel = [
        ...pages, ...pages, ...pages
      ].slice(this.wheelCurrentPageIndex, this.wheelCurrentPageIndex + 7)
    },
    wheelTransitionEnd() {
      if(this.spinClass === 'spinClockwise') {
        this.wheelCurrentPageIndex = (this.wheelCurrentPageIndex - 1 + pages.length) % pages.length
      } else if(this.spinClass === 'spinCounterClockwise') {
        this.wheelCurrentPageIndex = (this.wheelCurrentPageIndex + 1) % pages.length
      }
      this.updateBufferWheel()
      requestAnimationFrame(() => requestAnimationFrame(() => {
        this.spinClass = ''
        this.wheel = [...this.bufferWheel]
        if(this.queue.length) {
          requestAnimationFrame(() => requestAnimationFrame(this.queue.shift()))
        }
      }))
    },
    contentWrapperTransitionEnd() {
      if(this.transitionTo !== false) {
        this.currentPageIndex = this.transitionTo
        this.transitionTo = false
        this.transitionDirection = ''
        history.replaceState({}, '', `/cioccolato/${pages[this.currentPageIndex].slug}`)
      }
    },
    spinClockwise(onComplete = false) {
      if(onComplete) {
        this.queue.push(onComplete)
      }
      this.spinClass = 'spinClockwise'
      this.transitionDirection = 'clockwise'
      const transitionTo = (this.currentPageIndex - 1 + pages.length) % pages.length
      requestAnimationFrame(() => this.transitionTo = transitionTo)
    },
    spinCounterClockwise(onComplete = false) {
      if(onComplete) {
        this.queue.push(onComplete)
      }
      this.spinClass = 'spinCounterClockwise'
      this.transitionDirection = 'counterClockwise'
      const transitionTo = (this.currentPageIndex + 1) % pages.length
      requestAnimationFrame(() => this.transitionTo = transitionTo)
    },
    scrollToContentStart() {
      const contentWrapper = this.$el.querySelector('.contentWrapper')
      if(contentWrapper) {
        const top = contentWrapper.getBoundingClientRect().top + window.scrollY - (matchMedia("(width > 768px)").matches ? 155 : 90)
        window.scrollTo({ top, behavior: 'smooth' })
      }
    },
    packClick(index) {
      switch(index) {
        case 1:
          this.spinClockwise(() => this.spinClockwise())
          break
        case 2:
          this.spinClockwise()
          break
        case 4:
          this.spinCounterClockwise()
          break
        case 5:
          this.spinCounterClockwise(() => this.spinCounterClockwise())
          break
      }
      this.scrollToContentStart()
    },
    navClick(index) {
      switch(index) {
        case this.currentPageIndex:
          break
        case (this.currentPageIndex + 1) % pages.length:
          this.spinCounterClockwise()
          break
        case (this.currentPageIndex - 1 + pages.length) % pages.length:
          this.spinClockwise()
          break
      }
      this.scrollToContentStart()
    }
  }
}
</script>

<style lang="scss" scoped>
section {
  padding-top: 37px;
  @media screen and (max-width:768px) {
    padding-top: 0;
  }
}
nav {
  background-color: #000;
  padding: 0 10%;
  position: fixed;
  z-index: 11;
  top: 120px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  font-size: #{1.7rem * 0.625};
  flex-wrap: wrap;
  text-transform: uppercase;
  height: 37px;
  @media screen and (max-width: 1024px) {
    padding: 0 5%;
  }
  @media screen and (max-width:768px) {
    display: none;
  }
  a {
    color: #fff;
    padding: 10px 15px;
    font-weight: 600;
    opacity: .5;
    &:hover {
      opacity: 1;
    }
    &.active {
      transform: scale(1.3);
      opacity: 1;
    }
  }
}
.heroCioccolato {
  padding: 30px 16vw 90px;
  text-align: center;
  @media screen and (max-width: 600px) {
    padding: 30px 8vw 90px;
  }
  h1 {
    font-weight: 600;
    font-size: 48px;
    @media screen and (max-width: 600px) {
      font-size: 32px;
    }
  }
  div {
    font-size: 25px;
    line-height: 1.5;
    font-weight: 300;
    @media screen and (max-width: 600px) {
      font-size: 20px;
    }
  }
  a {
    font-size: 25px;
    font-family: caecilia, sans-serif;
    text-decoration: underline;
    white-space: nowrap;
    @media screen and (max-width: 600px) {
      font-size: 20px;
    }
  }
}
.packWheel {
  position: relative;
  text-align: center;
  overflow: hidden;
  height: 400px;
  max-height: 50vw;
  @media screen and (max-width: 600px) {
    max-height: 350px;
  }
  @media screen and (max-width: 450px) {
    max-height: 320px;
  }
  a {
    position: absolute;
    top: 0;
    left: 50%;
    width: 420px;
    margin-left: max(-210px, -20vw);
    max-width: 40vw;
    @media screen and (max-width: 600px) {
      margin-left: max(-210px, -30vw);
      max-width: 60vw;
    }
    transition: none;
    display: block;
    img {
      width: 100%;
      height: auto;
      display: block;
      + img {
        display: none;
      }
    }
    div {
      padding-top: 20px;
      text-transform: uppercase;
      font-size: 20px;
      opacity: 0;
      pointer-events: none;
      span + span {
        display: none;
      }
    }
    &:nth-child(1) {
      transform: translate(-240%, 120%) scale(0.4) rotate(-40deg);
    }
    &:nth-child(2) {
      transform: translate(-180%, 50%) scale(0.5) rotate(-30deg);
    }
    &:nth-child(3) {
      transform: translate(-100%, 0) scale(0.6) rotate(-15deg);
    }
    &:nth-child(4) {
      transform: translate(0, 0) scale(1) rotate(0deg);
      div {
        opacity: 1;
      }
    }
    &:nth-child(5) {
      transform: translate(100%, 0) scale(0.6) rotate(15deg);
    }
    &:nth-child(6) {
      transform: translate(180%, 50%) scale(0.5) rotate(30deg);
    }
    &:nth-child(7) {
      transform: translate(240%, 120%) scale(0.4) rotate(40deg);
    }
  }
  &.spinClockwise,
  &.spinCounterClockwise {
    a {
      pointer-events: none;
      transition: transform .4s ease-in-out;
    }
    div {
      transition: opacity .4s ease-in-out;
      span {
        display: none;
        + span {
          display: block;
        }
      }
    }
    img {
      display: none;
      + img {
        display: block;
      }
    }
  }
  &.spinClockwise a {
    &:nth-child(1) {
      transform: translate(-180%, 50%) scale(0.5) rotate(-30deg);
    }
    &:nth-child(2) {
      transform: translate(-100%, 0) scale(0.6) rotate(-15deg);
    }
    &:nth-child(3) {
      transform: translate(0, 0) scale(1) rotate(0deg);
      div {
        opacity: 1;
      }
    }
    &:nth-child(4) {
      transform: translate(100%, 0) scale(0.6) rotate(15deg);
      div {
        opacity: 0;
      }
    }
    &:nth-child(5) {
      transform: translate(180%, 50%) scale(0.5) rotate(30deg);
    }
    &:nth-child(6) {
      transform: translate(240%, 120%) scale(0.4) rotate(40deg);
    }
  }
  &.spinCounterClockwise a {
    &:nth-child(2) {
      transform: translate(-240%, 120%) scale(0.4) rotate(-40deg);
    }
    &:nth-child(3) {
      transform: translate(-180%, 50%) scale(0.5) rotate(-30deg);
    }
    &:nth-child(4) {
      transform: translate(-100%, 0) scale(0.6) rotate(-15deg);
      div {
        opacity: 0;
      }
    }
    &:nth-child(5) {
      transform: translate(0, 0) scale(1) rotate(0deg);
      div {
        opacity: 1;
      }
    }
    &:nth-child(6) {
      transform: translate(100%, 0) scale(0.6) rotate(15deg);
    }
    &:nth-child(7) {
      transform: translate(180%, 50%) scale(0.5) rotate(30deg);
    }
  }
}
.contentWrapper {
  overflow: hidden;
  position: relative;
  > * {
    overflow: hidden;
  }
  > :not(.current) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    transform: translateX(-100%);
  }
  &.counterClockwise {
    > :not(.current) {
      transform: translateX(100%);
    }
  }
  &.transitioning {
    > * {
      transition: transform .4s ease-in-out;
    }
    .next {
      transform: translateX(0);
    }
    &.clockwise {
      .current {
        transform: translateX(100%);
      }
    }
    &.counterClockwise {
      .current {
        transform: translateX(-100%);
      }
    }
  }
}
.intro {
  background-color: var(--cioccolato-color);
  color: #fff;
  overflow: hidden;
  padding: 75px 50px;
  text-align: center;
  @media screen and (min-width: 769px) {
    min-height: 50vh;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 768px) {
    padding: 50px 20px;
  }
  h3 {
    font-weight: 600;
    font-size: 48px;
    margin: 0;
    @media screen and (max-width: 768px) {
      font-size: 32px;
    }
  }
  div {
    width: 950px;
    max-width: 100%;
    margin: 20px auto 0;
    font-size: 25px;
    line-height: 1.5;
    font-weight: 300;
    @media screen and (max-width: 768px) {
      font-size: 20px;
    }
  }
}
.schema {
  text-align: center;
  position: relative;
  padding: 130px 0 150px;
  font-size: 20px;
  letter-spacing: 1px;
  line-height: 1.2;
  max-width: 1600px;
  margin: 0 auto;
  @media screen and (max-width:768px) {
    display: none;
  }
  .pack {
    width: 600px;
    max-width: calc(100% - 500px);
    margin: 0 auto;
    position: relative;
    z-index: 1;
    img {
      width: 100%;
      height: auto;
      display: block;
      transform: scale(1.05);
      filter: grayscale(1) brightness(500%);
      + img {
        position: absolute;
        top: 0;
        left: 0;
        transform: none;
        filter: none;
      }
    }
  }
  h4 {
    margin: 0 0 10px;
  }
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  li {
    position: absolute;
    width: 200px;
    margin: 0;
    @media screen and (max-width: 1350px) {
      transform: scale(.9);
    }
    @media screen and (max-width: 900px) {
      transform: scale(.85);
    }
    svg.line {
      position: absolute;
      path {
        stroke: var(--cioccolato-color);
        stroke-width: 2;
        fill: none;
      }
    }
    &:nth-child(1) {
      transform-origin: top left;
      top: 5%;
      left: 5%;
      svg.line {
        top: 65px;
        left: 100%;
        margin-left: 10px;
        width: 215px
      }
    }
    &:nth-child(2) {
      transform-origin: top right;
      top: 8%;
      right: 5%;
      svg.line {
        top: 65px;
        right: 100%;
        margin-right: -10px;
        width: 235px
      }
    }
    &:nth-child(3) {
      transform-origin: bottom left;
      bottom: 5%;
      left: 5%;
      svg.line {
        bottom: 100%;
        margin-bottom: -65px;
        left: 100%;
        margin-left: -10px;
        width: 235px
      }
    }
    &:nth-child(4) {
      transform-origin: bottom right;
      width: 320px;
      bottom: 2%;
      right: 2%;
      svg.line {
        bottom: 100%;
        margin-bottom: -65px;
        right: 50%;
        margin-right: 55px;
        width: 260px
      }
    }
  }
}
.highlightIcon {
  fill: var(--cioccolato-color);
  width: 50px;
  display: inline-block;
}
.cta {
  position: absolute;
  text-transform: uppercase;
  text-align: center;
  width: 100%;
  transform: translateY(-110px);
  @media screen and (max-width: 1024px) {
    position: static;
    transform: none;
    margin: 10px 8vw 30px;
    width: auto;
  }
}
.supplier {
  background-color: #f0efef;
  padding: 2vw 4vw;
}
.supplierImage {
  width: 100%;
  height: auto;
  display: block;
  box-sizing: border-box;
  pointer-events: none;
}
.supplierDetails {
  margin-top: 2vw;
  display: flex;
  align-items: stretch;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
}
.supplierMap {
  fill: var(--cioccolato-color);
  width: 35%;
  float: left;
  flex: 0 0 35%;
  @media screen and (max-width: 768px) {
    width: 80%;
    flex: 0 0 auto;
    margin-top: 15px;
  }
}
.supplierText {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10vw;
  text-align: center;
  @media screen and (max-width: 768px) {
    padding: 5vw;
  }
  h3 {
    color: var(--cioccolato-color);
    white-space: pre-line;
    margin: 0;
    font-size: 32px;
    line-height: 1.2;
    @media screen and (max-width: 768px) {
      font-size: 24px;
    }
  }
  div,
  a {
    font-size: 20px;
    line-height: 1.875rem;
    font-family: caecilia, sans-serif;
    @media screen and (max-width: 768px) {
      font-size: 18px;
    }
  }
  a {
    text-decoration: underline;
  }
}
.arrowBtn--left,
.arrowBtn--right {
  position: relative;
  overflow: hidden;
  color: transparent;
  padding: 0;
  border: none;
  height: 1em;
  width: 1em;
  cursor: pointer;
  border-radius: 50%;
  font-family: ForkAwesome;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1;
  &::before {
    font-size: .6em;
    position: absolute;
    top: .41em;
    color: #fff;
  }
}
.arrowBtn--left::before {
  content: "\f053";
  left: .5em;
}
.arrowBtn--right::before {
  content: "\f054";
  right: .5em;
}
.wheelArrows {
   position: absolute;
   transform: translate(-50%, -180%);
   left: 50%;
   .arrowBtn--left,
   .arrowBtn--right {
      background: #4c4c4c;
      font-size: 40px;
      margin: 0 7px;
   }
}
.schemaCarousel {
  display: none;
  @media screen and (max-width:768px) {
    display: block;
    text-align: center;
    position: relative;
    padding: 30px 0 25px;
    font-size: 20px;
    letter-spacing: 1px;
    line-height: 1.2;
    max-width: 1600px;
    margin: 0 auto;
    .pack {
      width: 600px;
      max-width: 86vw;
      height: auto;
      display: block;
      margin: 0 auto 25px;
      position: relative;
      z-index: 1;
    }
    .schemaCarouselWrapper {
      background-color: #f0efef;
      .slick-slide {
        outline: none;
        padding: 0 20px;
        box-sizing: border-box;
      }
      .content {
        padding: 20px 50px;
        h4 {
          margin-top: 0;
        }
        .highlightIcon {
          width: 65px;
        }
      }
    }
  }
}
.button {
  height: auto;
  line-height: 1.2;
  padding: 10px 58px;
}
</style>
<style lang="scss">
.suppliersWrapper {
  .slick-arrow {
    z-index: 1;
    position: absolute;
    top: 40.75vw;
    margin-top: 100px;
    overflow: hidden;
    color: transparent;
    padding: 0;
    border: none;
    height: 1em;
    width: 1em;
    cursor: pointer;
    border-radius: 50%;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1;
    background: #000;
    font-size: min(60px, 8vw);
    &::before {
      font-family: ForkAwesome;
      opacity: 1;
      font-size: .6em;
      position: absolute;
      top: .41em;
      color: #fff !important;
    }
  }
  .slick-prev::before {
    content: "\f053";
    left: .5em;
  }
  .slick-next::before {
    content: "\f054";
    right: .5em;
  }
  .slick-prev {
    left: 1vw;
  }
  .slick-next {
    right: 1vw;
  }
}
</style>
